import {
  BooleanInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required,
  SelectInput,
  UrlField,
  ReferenceInput
} from 'react-admin';
import { UploadInput } from '../../components';

export default function UtilitiesForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        fullWidth
        autoComplete="off"
        label="Nome"
        source="name"
        validate={[required()]}
      />

      <UploadInput
        fullWidth
        helperText="É possível enviar imagens no formato SVG."
        label="Ícone"
        mimeTypes={['.svg']}
        source="icon"
        validate={[required()]}
      />

        <ReferenceInput
          fullWidth
          label="Categoria"
          sort={{ field: 'position', order: 'ASC' }}
          source="category"
          reference="utility-categories"
          validate={[required()]}
        >
          <SelectInput />
        </ReferenceInput>

      <TextInput fullWidth label="URL" source="link" validate={[required()]} />

      <SelectInput
        choices={[
          { id: '_self', name: 'Mesma janela' },
          { id: '_blank', name: 'Nova aba' }
        ]}
        label="Abrir em"
        source="target"
        validate={[required()]}
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
